import {useFeatureFlagLanguages} from '@/hooks/useFeatureFlagLanguages'
import {DisplayLanguageSection} from './DisplayLanguageSection'

export const DisplayTab = () => {
  const languages = useFeatureFlagLanguages()

  return (
    <div className="grid grid-cols-2 items-start gap-3">
      {languages.map(language => (
        <DisplayLanguageSection key={language.code} language={language} />
      ))}
    </div>
  )
}
